import { Injectable } from '@angular/core';
import { DeviceService } from 'src/app/services/device/device.service';
import { CommonService } from 'src/app/services/common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';

@Injectable({
	providedIn: 'root'
})
export class PowerContainer {
	private readonly dpmBrands = ['think', 'lenovo'];
	private readonly dpmSubBrands = ['thinkcentre', 'thinkcenter'];

	constructor(
		private deviceService: DeviceService,
		private commonService: CommonService
	) {}

	public async isDPMToBePresented() {
		const cache = this.getDPMCache();
		if (cache !== undefined) {
			return cache;
		} else {
			return await this.getDPMCapability();
		}
	}

	private async getDPMCapability() {
		const machineInfo = await this.deviceService.getMachineInfo();
		if (!machineInfo) {
			return false;
		}
		const brand = machineInfo.brand.toLowerCase();
		const subBrand = machineInfo.subBrand.toLowerCase();
		const brandAndSubBrandMatchDPM = this.dpmBrands.includes(brand) && this.dpmSubBrands.includes(subBrand);
		return brandAndSubBrandMatchDPM;
	}

	private getDPMCache() {
		return this.commonService.getLocalStorageValue(LocalStorageKey.IsDPMSupported, undefined);
	}
}
